import { useRouter } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ErrorDisplay } from './error-display.tsx';

export function RouteError() {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <main className="max-w-2xl mx-auto px-6 py-16">
      <ErrorDisplay
        error={t('common.genericError')}
        onRetry={() => router.invalidate()}
      />
    </main>
  );
}
